import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import Progress from "./customer/components/Progress";
import Footer from "./customer/components/Footer";
import Step1 from "./customer/pages/Step1";
import Step2 from "./customer/pages/Step2";
import Step3 from "./customer/pages/Step3";
import Step4 from "./customer/pages/Step4";
import Step5 from "./customer/pages/Step5";
import Step6 from "./customer/pages/Step6";
import Success from "./customer/pages/Success";
import BackofficeRoutes from "./backoffice/routes/BackofficeRoutes";
import { Toaster } from "sonner";
import { LoadScript } from "@react-google-maps/api";
const initialData = { moveType: "Residential Move", from: "", to: "", date: "", houseType: "", items: {}, services: [], name: "", phone: "", email: "", whatsapp: "", };
function CustomerApp() {
  const libraries = ["places"];
  const [step, setStep] = useState(1);
  const [data, setData] = useState(initialData);
  const next = () => {
    setStep((s) => Math.min(6, s + 1));
  };
  const back = () => {
    setStep((s) => Math.max(1, s - 1));
  };
  const submit = () => {
    setStep(7);
  };
  const restart = () => {
    setData(initialData);
    setStep(1);
  };
  if (step === 7) {
    return (
      <>
        <Success data={data} restart={restart} />
        <Footer />
      </>
    );
  }
  return (
    <LoadScript googleMapsApiKey="AIzaSyC-z2blVw7iQi4_j8v1rwkf2l5oecEkH54" libraries={libraries}    >
      <Progress current={step} />
      <div className="container content-area">
        {step === 1 && (
          <Step1 data={data} setData={setData} next={next} />
        )}
        {step === 2 && (
          <Step2 data={data} setData={setData} next={next} back={back} />
        )}
        {step === 3 && (
          <Step3 data={data} setData={setData} next={next} back={back} />
        )}
        {step === 4 && (
          <Step4 data={data} setData={setData} next={next} back={back} />
        )}
        {step === 5 && (
          <Step5 data={data} setData={setData} next={next} back={back} />
        )}
        {step === 6 && (
          <Step6 data={data} back={back} submit={submit}
          />
        )}
      </div>
      <Toaster position="top-right" richColorscloseButtonduration={3000} expand={true} />
    </LoadScript>
  );
}
export default function App() {
  return (
    <Routes>
      <Route path="/backoffice/*" element={<BackofficeRoutes />} />
      <Route path="/*" element={<CustomerApp />} />
    </Routes>
  );
}